import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import * as AOS from 'aos/dist/aos.js';
AOS.init();

// slider
import { tns } from "tiny-slider/src/tiny-slider";

[].forEach.call(document.querySelectorAll('.slider'), function (el) {
    tns({
        container: el,
        slideBy: 'page',
        autoplay: true,
        controls: false,
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        autoplayTimeout : 3000,
    });
});

[].forEach.call(document.querySelectorAll('.slider__partenaires'), function (el) {
    tns({
        container: el,
        items: 1,
        slideBy: 1,
        autoplay: true,
        controls: true,
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        nav: false,
        autoplayTimeout : 3000,
        controlsContainer: "#customize-controls",
        responsive: {
            640: {
                items: 5
            }
        }
    });
});

const accordionHeader = document.querySelectorAll(".accordion-header");
accordionHeader.forEach((header) => {
    header.addEventListener("click", function () {
        const accordionContent = header.parentElement.querySelector(".accordion-content");
        let accordionMaxHeight = accordionContent.style.maxHeight;

        // Condition handling
        if (accordionMaxHeight == "0px" || accordionMaxHeight.length == 0) {
            accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 32}px`;
            header.querySelector(".arrow").classList.add("rotate-180");
        } else {
            accordionContent.style.maxHeight = `0px`;
            header.querySelector(".arrow").classList.remove("rotate-180");
        }
    });
});
